//src/pages/admin/dashboard/tabs/staffs/EditStaff.jsx

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import {
//   getStaffById,
//   updateStaffPermission,
//   updateStaffStatus,
// } from "../../../../../services/api";
import { adminApi } from "../../../../../services/index";

export default function EditStaff() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [staff, setStaff] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0); // 0: Permissions, 1: Status
  const [saving, setSaving] = useState(false);

  const [permissions, setPermissions] = useState({});
  const [status, setStatus] = useState(true);

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const res = await adminApi.getStaffById(id);
        const data = res?.data?.data;
        setStaff(data);
        setPermissions(data.permissions);
        setStatus(data.isActive);
      } catch {
        alert("Failed to fetch staff");
      } finally {
        setLoading(false);
      }
    };
    fetchStaff();
  }, [id]);

  const handlePermissionChange = (e) => {
    const { name, checked } = e.target;
    setPermissions({ ...permissions, [name]: checked });
  };

  const handleStatusChange = (e) => {
    const value = e.target.value === "true";
    setStatus(value);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      if (activeTab === 0) {
        // Send the permissions object
        await adminApi.updateStaffPermission(id, permissions);
        alert("Permissions updated successfully!");
      } else if (activeTab === 1) {
        // Send the boolean status
        await adminApi.updateStaffStatus(id, status);
        alert("Status updated successfully!");
      }
      navigate("/admin-dashboard/staffs");
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Operation failed!");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!staff) return <p>No staff found</p>;

  const tabs = [
    { label: "Modify Permissions" },
    { label: "Modify Status" },
  ];

  return (
    <div className="container-fluid p-4">
      <h2 className="mb-4">
        Edit Staff: <span className="text-primary">{staff.name}</span>
      </h2>

      {/* Tabs */}
      <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveTab(index)}
            className={`btn ${
              activeTab === index ? "btn-primary" : "btn-outline-primary"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div style={{ padding: "20px", borderRadius: "5px", backgroundColor: "#f8f9fa" }}>
        {activeTab === 0 && (
          <div>
            <h5 className="mb-3">Update Permissions</h5>
            <fieldset className="mb-3">
              {["canCredit", "canDebit", "canCreateUser", "canViewReports"].map(
                (perm) => (
                  <div className="form-check mb-2" key={perm}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={perm}
                      name={perm}
                      checked={permissions[perm] || false}
                      onChange={handlePermissionChange}
                    />
                    <label className="form-check-label" htmlFor={perm}>
                      {perm.replace("can", "Can ")}
                    </label>
                  </div>
                )
              )}
            </fieldset>
            <button
              className="btn btn-primary"
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? "Saving..." : "Save Permissions"}
            </button>
          </div>
        )}

        {activeTab === 1 && (
          <div>
            <h5 className="mb-3">Change Status</h5>
            <div className="mb-3">
              <label className="form-label">Current Status</label>
              <select
                className="form-select"
                value={status}
                onChange={handleStatusChange}
              >
                <option value={true}>Active</option>
                <option value={false}>Inactive</option>
              </select>
            </div>
            <button
              className="btn btn-primary"
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? "Saving..." : "Update Status"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
